<template>
  <div class="signed-contracts container container_30">
    <div class="signed-contracts__header">
      <searcher @compose-filters="loadFilteredContracts"/>
      <div class="signed-contracts__dispute-filter">
        <md-switch class="md-primary"
                  v-model="filters.isDisputing">
        {{ i18n.cont_show_active_disputes() }}
        </md-switch>
      </div>
    </div>
    <md-table class="signed-contracts__table">
      <template v-if="list.length">
        <md-table-row class="signed-contracts_row">
          <md-table-head>{{ i18n.cont_counterparty() }}</md-table-head>
          <md-table-head>{{ i18n.cont_contract_number() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_start_date() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_end_date() }}</md-table-head>
          <md-table-head>{{ i18n.cont_active_disputes() }}</md-table-head>
          <md-table-head><!--Button--></md-table-head>
        </md-table-row>
        <template v-for="(item, i) in list">
          <md-table-row class="signed-contracts__row" :key="i">
            <md-table-cell class="signed-contracts__table-cell counterparty-cell">
              <company-name-getter :id="item.contractor" />
            </md-table-cell>
            <md-table-cell class="signed-contracts__table-cell">{{ item.contractNumber }}</md-table-cell>
            <md-table-cell class="signed-contracts__table-cell">{{ i18n.d(item.startDate) }}</md-table-cell>
            <md-table-cell class="signed-contracts__table-cell">{{ i18n.d(item.endDate) }}</md-table-cell>
            <md-table-cell class="signed-contracts__table-cell">{{ item.isDisputing ? i18n.lbl_yes() :  i18n.lbl_no() }}</md-table-cell>
            <md-table-cell class="signed-contracts__table-cell">
              <md-button class="signed-contracts__view-details-btn md-icon-button"
                        @click="openDetails(item.id)">
                <md-icon>keyboard_arrow_right</md-icon>
              </md-button>
            </md-table-cell>

          </md-table-row>
        </template>
         <md-table-row v-if="!isLoaded">
            <md-table-cell colspan="7">
                <div class="signed-contracts__btn-outer">
                <md-button @click="more" :disabled="isLoading" class="md-primary">{{ i18n.lbl_view_more() }}</md-button>
                </div>
            </md-table-cell>
         </md-table-row>
      </template>
      <template v-else>
        <div class="signed-contracts__no-contracts">
          <md-icon class="md-size-4x">trending_up</md-icon>
          <h2>{{ i18n.cont_no_signed_contracts() }}</h2>
          <p>{{ i18n.cont_no_signed_contracts_desc() }}</p>
        </div>
      </template>
    </md-table>
  </div>
</template>

<script>
import Searcher from '../Contracts.Searcher'
import get from 'lodash/get'

import { mapGetters, mapActions } from 'vuex'
import { i18n } from '@js/i18n'
import { documentTypes,
  ASSET_POLICIES_VERBOSE,
  CONTRACTS_DETAILS_TYPES } from '@const'
import { vuexTypes } from '@vuex/types'
import CompanyNameGetter from '@vue/app/common/CompanyNameGetter'
import debounce from 'lodash/debounce'
import { EventDispatcher } from '@js/events/event_dispatcher'

export default {
  components: { Searcher,
    CompanyNameGetter },
  data: _ => ({
    i18n,
    documentTypes,
    isLoading: false,
    filters: {
      counterparty: '',
      contractNumber: '',
      startTime: '',
      endTime: '',
      isDisputing: '',
      source: '',
      isCompleted: false
    },
    ASSET_POLICIES_VERBOSE
  }),

  async created () {
    await this.loadFilteredContracts()
  },

  computed: {
    ...mapGetters([
      vuexTypes.signedContracts,
      vuexTypes.accountId
    ]),
    list () {
      return get(this.signedContracts, 'records', [])
    },
    isLoaded () {
      return get(this.signedContracts, 'isLoaded')
    }
  },

  methods: {
    ...mapActions({
      loadList: vuexTypes.GET_SIGNED_CONTRACTS,
      loadNext: vuexTypes.NEXT_SIGNED_CONTRACTS
    }),
    async more () {
      this.isLoading = true
      try {
        await this.loadNext()
      } catch (e) {
        console.error(e)
        EventDispatcher.dispatchShowErrorEvent(i18n.th_failed_to_load_tx())
      }
      this.isLoading = false
    },
    loadFilteredContracts (filters) {
      this.filters.source = this.accountId
      if (filters) {
        this.filters.counterparty = filters.counterparty
        this.filters.contractNumber = filters.contractNumber
        this.filters.startTime = filters.startDate
        this.filters.endTime = filters.endDate
      }
      return this.loadList(this.filters)
    },
    openDetails (id) {
      this.$emit('open-details', {id: id, type: CONTRACTS_DETAILS_TYPES.signed})
    }
  },
  watch: {
    'filters.isDisputing': debounce(function (value) {
      if (value) this.loadFilteredContracts()
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

.signed-contracts {
    background: $default-white;
  }

  .signed-contracts__table {
    margin-top: 1.5rem;
    // md-card styles
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
  }

  .counterparty-cell {
    min-width: 450px;
  }

  .signed-contracts__view-details-btn {
    float: right;
  }

  .signed-contracts__no-contracts {
    margin: 1rem auto;
    text-align: center;
  }

/*
  .signed-contracts__header { background: $col-content-block; }
*/

  .signed-contracts__dispute-filter { margin-left: 2.5rem; }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/signed/Contracts.SignedList.vue